import { useState, useEffect } from "react";
import { CLASS_META, DAYS, STORE_KEY, DAYS_STORE_KEY } from "./data";

const initFromStore = (urlKey, storeKey, isValid) => {
  try {
    const fromUrl = new URLSearchParams(window.location.search).get(urlKey);
    if (fromUrl) {
      const arr = fromUrl.split(",").map(decodeURIComponent).filter(isValid);
      if (arr.length) return arr;
    }
    const saved = JSON.parse(localStorage.getItem(storeKey) || "[]");
    return Array.isArray(saved) ? saved.filter(isValid) : [];
  } catch {
    return [];
  }
};

// Owns the class / day / availability selection, persisting to localStorage
// and hydrating from the URL query string (for shareable links).
export function useTimetableFilters() {
  const [selected, setSelected] = useState(() =>
    initFromStore("classes", STORE_KEY, (n) => CLASS_META[n])
  );
  const [selectedDays, setSelectedDays] = useState(() =>
    initFromStore("days", DAYS_STORE_KEY, (d) => DAYS.includes(d))
  );
  const [availableOnly, setAvailableOnly] = useState(false);

  useEffect(() => {
    localStorage.setItem(STORE_KEY, JSON.stringify(selected));
  }, [selected]);

  useEffect(() => {
    localStorage.setItem(DAYS_STORE_KEY, JSON.stringify(selectedDays));
  }, [selectedDays]);

  const toggle = (name) =>
    setSelected((prev) => (prev.includes(name) ? prev.filter((n) => n !== name) : [...prev, name]));
  const clearAll = () => setSelected([]);
  const toggleDay = (day) =>
    setSelectedDays((prev) => (prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]));
  const clearDays = () => setSelectedDays([]);

  return {
    selected, selectedDays, availableOnly,
    setAvailableOnly, toggle, clearAll, toggleDay, clearDays,
  };
}
